import { CellProps } from "react-table";
import ListTextCell from "src/apps/super-admin/tabs/roles/list/PermissionCell";
import Status from "src/components/status/Status";
import TextCell from "src/components/tables/cells/TextCell";
import {
  INVENTORY_REQUEST_STATUS,
  INVENTORY_REQUEST_STATUS_CELL,
} from "src/utils/constants";
import { InventoryType } from "./inventory-types";

const useInventoryRequestTableColumns = ({
  onDelete,
}: {
  onDelete: (id: number) => void;
}) => {
  return [
    {
      Header: "Product Name",
      accessor: "products",
      className: "min-w-[180px]",
      Cell: ListTextCell,
    },
    {
      Header: "Quantity",
      accessor: "totalQuantity",
      className: "min-w-[150px]",
      Cell: TextCell,
    },
    {
      Header: "Price (₹)",
      accessor: "totalPrice",
      className: "min-w-[150px]",
      Cell: TextCell,
    },
    {
      Header: "Status",
      accessor: "status",
      className: "min-w-[150px]",
      Cell: ({ value }: CellProps<InventoryType>) => {
        const status =
          INVENTORY_REQUEST_STATUS_CELL[value as INVENTORY_REQUEST_STATUS];
        return <Status {...status} />;
      },
    },
  ];
};

export default useInventoryRequestTableColumns;
